import { ApiTimeOffLogFullRejectCode } from "@/types/time-off/time-off.types.ts";
import { Stack, Text } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export function TimeOffRequestRejectInfo({ code }: { code: ApiTimeOffLogFullRejectCode }) {
  const { t } = useTranslation();
  const error = t(`time_off:reject_code_${code}`);

  switch (code) {
    case ApiTimeOffLogFullRejectCode.asked_less_then_min_daily_amount:
    case ApiTimeOffLogFullRejectCode.asked_less_then_min_request_total:
    case ApiTimeOffLogFullRejectCode.asked_more_then_max_request_total:
    case ApiTimeOffLogFullRejectCode.asked_date_from_less_then_min_notice_period:
    case ApiTimeOffLogFullRejectCode.asked_date_from_more_then_max_notice_period:
  }

  return (
    <Stack className={"h-14"} justify={"center"}>
      <Text className={"text-danger"}>{error}</Text>
    </Stack>
  );
}
